export const FOOTER_SPLASH_TEXT =
  "Villa Homes  |  1 Letterman Dr., Suite C3500, San Francisco, CA 94129  |  CSLB#1077688  |  HCD# DL1564605";
